{
  "tabs": {
    "chat": "කතාබස්",
    "reminders": "ඇමතුම්",
    "calendar": "දින දර්ශනය",
    "settings": "සැකසුම්"
  },
  "common": {
    "cancel": "අවලංගු කරන්න",
    "save": "සුරකින්න",
    "confirm": "තහවුරු කරන්න",
    "delete": "මකන්න",
    "back": "ආපසු",
    "close": "වසන්න",
    "edit": "සංස්කරණය",
    "search": "සෙවීම",
    "all": "සියලු",
    "loading": "පූරණය වෙමින්...",
    "error": "කිසිවක් වැරදි විය",
    "notFound": "නොපැවතියි",
    "tryAgain": "කරුණාකර නැවත උත්සාහ කරන්න",
    "retry": "නැවත උත්සාහ කරන්න",
    "undo": "ආපසු ගන්න",
    "pullToRefresh": "නවීකරණය සඳහා ඇදන්න",
    "justNow": "දැන්ම"
  },
  "auth": {
    "welcome": "FishMemory වෙත සාදරයෙන් පිළිගනිමු",
    "tagline": "ඔබේ WhatsApp ඇමතුම් සහායකයා, දැන් ඔබේ කෙළවරේ.",
    "subtitle": "ඔබේ WhatsApp ඇමතුම් සහායකයා, දැන් ඔබේ කෙළවරේ.",
    "phoneLabel": "ඔබේ WhatsApp අංකය",
    "phoneHint": "WhatsApp හරහා සත්‍යාපන කේතයක් අපි එවන්නෙමු",
    "invalidPhone": "කරුණාකර වලංගු දුරකථන අංකයක් ඇතුළත් කරන්න",
    "continue": "ඉදිරියට යන්න",
    "enterPhone": "ඔබේ WhatsApp අංකය ඇතුළත් කරන්න",
    "phonePlaceholder": "දුරකථන අංකය",
    "sendCode": "කේතය යවන්න",
    "verifyTitle": "ඔබේ අංකය සත්‍යාපනය කරන්න",
    "otpSentTo": "අංකයට WhatsApp හරහා අංක 6ක කේතයක් යවා ඇත: {{phone}}",
    "enterFullCode": "කරුණාකර සියලු අංක 6 ඇතුළත් කරන්න",
    "invalidOtp": "වලංගු නොවන කේතය. කරුණාකර නැවත උත්සාහ කරන්න.",
    "otpFailed": "කේතය යැවීමට අසමත් විය. නැවත උත්සාහ කරන්න.",
    "otpResent": "කේතය නැවත යවා ඇත",
    "resendIn": "{{seconds}} තත්පරයකින් නැවත යවන්න",
    "resendCode": "නැවත කේතය යවන්න",
    "enterOtp": "ඔබේ WhatsApp වෙතින් ලැබුණු කේතය ඇතුළත් කරන්න",
    "verify": "සත්‍යාපනය කරන්න",
    "resend": "නැවත කේතය යවන්න",
    "wrongNumber": "වැරදි අංකයක්ද?",
    "backToPhone": "දුරකථනයට ආපසු",
    "editPhone": "දුරකථන අංකය සංස්කරණය කරන්න",
    "error": "දෝෂයක්",
    "setupTitle": "සැකසුම් ආරම්භ කරමු",
    "setupSubtitle": "මෙම සැකසුම් පසුව Settings හි වෙනස් කළ හැක",
    "namePlaceholder": "ඔබේ නම",
    "letsGo": "සැකසුම් අවසන් කරන්න",
    "skipForNow": "දැන් ඉවතට"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "පණිවිඩයක් ටයිප් කරන්න...",
    "inputPlaceholder": "පණිවිඩයක් ටයිප් කරන්න...",
    "typing": "FishMemory ටයිප් කරමින්...",
    "online": "අන්තර්ජාලයේ",
    "connecting": "සම්බන්ධ වෙමින්...",
    "reconnecting": "නැවත සම්බන්ධ වෙමින්...",
    "offline": "අන්තර්ජාලයෙන් පිටත",
    "empty": "කතාබසක් ආරම්භ කරන්න",
    "emptyHint": "ඇමතුම් නිර්මාණය කරන්න, ඔබේ කාලසටහන පරීක්ෂා කරන්න, හෝ උදව් ඉල්ලන්න.",
    "emptyAction": "ආදර්ශ ඇමතුමක් යවන්න",
    "actions": "කතා ක්‍රියා",
    "keep": "පණිවිඩ තබන්න",
    "clearTitle": "කතා මකා දමන්න",
    "clearConfirm": "මෙම උපාංගයෙන් සියලු පණිවිඩ මකා දමන්නද? මෙය ආපසු ගත නොහැක.",
    "clear": "කතා මකා දමන්න",
    "optionSelected": "තෝරා ඇත: {{label}}",
    "sendingSelection": "යවමින්...",
    "connectionLost": "නැවත සම්බන්ධ වෙමින්..."
  },
  "reminders": {
    "title": "මගේ ඇමතුම්",
    "active": "සක්‍රීය",
    "today": "අද",
    "thisWeek": "මෙම සතිය",
    "history": "ඉතිහාසය",
    "items": "අයිතම",
    "emptyTitle": "තවම ඇමතුම් නැත",
    "emptySubtitle": "කතාබසෙන් එකක් නිර්මාණය කරන්න, මෙහි පෙන්වනු ඇත.",
    "emptyAction": "කතාබස විවෘත කරන්න",
    "filterActive": "සක්‍රීය",
    "filterToday": "අද",
    "filterWeek": "මෙම සතිය",
    "filterHistory": "ඉතිහාසය",
    "emptyState": "තවම ඇමතුම් නැත. කතාබස ආරම්භ කරන්න!",
    "swipeDone": "සම්පූර්ණයි",
    "swipeSnooze": "නිවන් කරන්න",
    "swipeDelete": "මකන්න",
    "search": "ඇමතුම් සෙවීම...",
    "upcoming": "ඉදිරියට",
    "completed": "සම්පූර්ණයි",
    "overdue": "කාලය ඉක්මවා ඇත",
    "tomorrow": "හෙට",
    "synced": "සමකාලීන කරන ලදි {{value}}",
    "swipeHint": "වැඩි ක්‍රියා සඳහා ඇමතුම ස්වයිප් කරන්න",
    "noResults": "ඔබගේ සෙවීමට ගැලපෙන ඇමතුම් නැත",
    "noResultsHint": "වෙනත් යතුරුපදයක් උත්සාහ කරන්න හෝ සෙවීම හිස් කරන්න",
    "deleteAllFailed": "සියලු ඇමතුම් මකීමට අසමත් විය"
  },
  "calendar": {
    "title": "දින දර්ශනය",
    "today": "අද",
    "tomorrow": "හෙට",
    "completed": "සම්පූර්ණයි",
    "noEvents": "කිසිවක් සැලසුම් කර නැත",
    "noEventsSubtitle": "ඇමතුම් සහ දින දර්ශන සිදුවීම් බලන්න දිනයක් තෝරන්න.",
    "googleEvent": "Google දින දර්ශනය",
    "legendActive": "සක්‍රීය",
    "legendRecurring": "පැවති",
    "legendDone": "සම්පූර්ණයි",
    "legendGoogle": "Google",
    "previousMonth": "පෙර මාසය",
    "nextMonth": "ඊළඟ මාසය",
    "previousYear": "පෙර වසර",
    "nextYear": "ඊළඟ වසර",
    "goToToday": "අදට යන්න",
    "all": "සියලු",
    "active": "සක්‍රීය",
    "done": "සම්පූර්ණයි",
    "paused": "විරාමය"
  },
  "settings": {
    "title": "සැකසුම්",
    "profile": "පැතිකඩ",
    "name": "පෙන්වෙන නම",
    "enterName": "ඔබේ නම ඇතුළත් කරන්න",
    "language": "භාෂාව",
    "uiLanguage": "යෙදුම් භාෂාව",
    "uiLanguageHelp": "මෙම උපාංගයේ යෙදුම් UI, දින දර්ශන ලේබල සහ සැලැස්ම වෙනස් කරයි.",
    "serverLanguage": "කතාබස් භාෂාව",
    "serverLanguageHelp": "ඔබගේ ගිණුම සඳහා සේවාදායක ප්‍රතිචාර සහ ඇමතුම් පණිවිඩ භාෂාව වෙනස් කරයි.",
    "timezone": "වේලා කලාපය",
    "currentTimezone": "වත්මන් වේලා කලාපය",
    "timezoneHelp": "සියලු ඇමතුම් වේලාවන් මෙම වේලා කලාපය අනුව පෙන්වයි.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "වේලා කලාපය සුරකින්න",
    "timezoneSaved": "වේලා කලාපය යාවත්කාලීන කරන ලදි",
    "detect": "හඳුනා ගන්න",
    "detectFailed": "වේලා කලාපය හඳුනා ගැනීමට නොහැකි විය",
    "autoDetect": "GPS මගින් ස්වයං හඳුනා ගැනීම",
    "notifications": "දැනුම්දීම්",
    "notificationsHelp": "ඇමතුම් පසු දැනුම්දීම්, ඇමතුමක් ලබා දුන් පසු නැවත දැනුම් දීම පාලනය කරයි. උපාංග මට්ටමේ දැනුම්දීම් අවසර ඔබේ දුරකථන සැකසුම් තුළින් පාලනය වේ.",
    "pushEnabled": "පූෂ් දැනුම්දීම්",
    "autoDoneOnFire": "ඇමතුම ක්‍රියාත්මක වූ විට ස්වයංක්‍රීය සම්පූර්ණ කිරීම",
    "autoDoneOnFireDesc": "අක්‍රීය නම්, ඇමතුම් ඔබ සම්පූර්ණ කළ විට තෙක් සක්‍රීයව පවතී.",
    "googleCalendar": "Google දින දර්ශනය",
    "google": "Google දින දර්ශනය",
    "googleConnected": "සම්බන්ධයි",
    "googleDisconnected": "සම්බන්ධ නොවෙයි",
    "googleConnectedHelp": "නව ඇමතුම් ස්වයංක්‍රීයව ඔබේ දින දර්ශනයට සමකාලීන කළ හැක.",
    "googleDisconnectedHelp": "Google දින දර්ශනය සම්බන්ධ කර ඇමතුම් සහ සිදුවීම් සමාන්තරව තබන්න.",
    "googleConnectFailed": "Google දින දර්ශනය සම්බන්ධ කිරීමට අසමත් විය",
    "connected": "සම්බන්ධයි",
    "disconnected": "සම්බන්ධ නොවෙයි",
    "connect": "සම්බන්ධ කරන්න",
    "disconnect": "සම්බන්ධතාවය කැපන්න",
    "autoSync": "නව ඇමතුම් ස්වයං සමකාලීන කිරීම",
    "autosync": "නව ඇමතුම් ස්වයං සමකාලීන කිරීම",
    "subscription": "දායකත්වය",
    "trialUsed": "ප්‍රථම පරීක්ෂණය: {{used}}/{{total}} භාවිතා කර ඇත",
    "trialStatus": "ප්‍රථම පරීක්ෂණය ලබා ගත හැක",
    "activeStatus": "සක්‍රීය දායකත්වය",
    "expiredStatus": "දායකත්ව කාලය අවසන්",
    "unsubscribedStatus": "දායක නොවෙයි",
    "about": "ගැන",
    "version": "සංස්කරණය",
    "logout": "පිටවීම",
    "logoutTitle": "පිටවීම",
    "logoutConfirm": "ඔබට පිටවීමට අවශ්‍ය බවට විශ්වාසද?",
    "noName": "නම සකසා නැත",
    "serverConnection": "සේවාදායක සම්බන්ධතාවය",
    "serverUrl": "සේවාදායක URL",
    "serverEdit": "සංස්කරණය",
    "saveReconnect": "සුරකින්න සහ නැවත සම්බන්ධ වන්න",
    "resetDefault": "පෙරනිමිති වෙත යළි සකසන්න",
    "invalidServerUrlTitle": "වලංගු නොවන සේවාදායක URL",
    "invalidServerUrlMessage": "http හෝ https සේවාදායක URL එකක් ඇතුළත් කරන්න, උදා: https://example.com",
    "uiLanguageChangeFailed": "යෙදුම් භාෂාව වෙනස් කිරීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
    "serverLanguageChangeFailed": "කතාබස් භාෂාව වෙනස් කිරීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
    "timezoneChangeFailed": "වේලා කලාපය වෙනස් කිරීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
    "autoSyncChangeFailed": "ස්වයං සමකාලීන කිරීම යාවත්කාලීන කිරීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
    "nameChangeFailed": "පෙන්වෙන නම යාවත්කාලීන කිරීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "ඇමතුම් විස්තර",
    "editTime": "වේලාව සංස්කරණය කරන්න",
    "rename": "නව නම දෙන්න",
    "snooze": "නිවන් කරන්න",
    "snooze15": "මිනිත්තු 15 කට නිවන් කරන්න",
    "pause": "විරාමය",
    "pauseReminder": "ඇමතුම විරාම කරන්න",
    "resume": "නැවත ආරම්භ කරන්න",
    "resumeReminder": "ඇමතුම නැවත ආරම්භ කරන්න",
    "skip": "ඊළඟ එක අතහැර යන්න",
    "skipOccurrence": "මෙම සිදුවීම අතහැර යන්න",
    "syncGoogle": "Google සමඟ සමකාලීන කරන්න",
    "delete": "මකන්න",
    "deleteTitle": "ඇමතුම මකන්න",
    "deleteConfirm": "මෙම ඇමතුම ස්ථිරවම මකා දමනු ඇත.",
    "deleteRecurringTitle": "පැවති ඇමතුම මකන්න",
    "deleteRecurringMessage": "මෙම සිදුවීම අතහැර යන්නද නැතහොත් සම්පූර්ණ මාලාව මකන්නද?",
    "deleteThisOccurrence": "මෙම සිදුවීම අතහැර යන්න",
    "deleteEntireSeries": "සම්පූර්ණ මාලාව මකන්න",
    "done": "සම්පූර්ණයි",
    "markDone": "සම්පූර්ණ ලෙස සලකුණු කරන්න",
    "undo": "ප්‍රතිස්ථාපනය කරන්න",
    "undoPrompt": "නැවත සක්‍රීය කිරීමට අවශ්‍යද? දැන් ප්‍රතිස්ථාපනය කරන්න.",
    "recurring": "පැවති",
    "nextRun": "ඊළඟ ධාවනය",
    "oneTime": "එක් වතාවක්",
    "pending": "පැවතී",
    "sent": "යවා ඇත",
    "paused": "විරාමය",
    "active": "සක්‍රීය",
    "snoozed": "නිවන් කළා",
    "localTime": "ඔබේ ප්‍රදේශීය වේලාවෙන් පෙන්වයි",
    "recurrence": "පැවතියි",
    "created": "තනන ලදි",
    "tags": "ටැග්",
    "fireCount": "ගණනාවක් ක්‍රියාත්මක විය",
    "actions": "ක්‍රියා",
    "none": "කිසිවක් නැත",
    "snoozeFailed": "ඇමතුම නිවන් කිරීමට අසමත් විය",
    "pauseFailed": "ඇමතුම විරාම කිරීමට අසමත් විය",
    "resumeFailed": "ඇමතුම නැවත ආරම්භ කිරීමට අසමත් විය",
    "skipFailed": "ඇමතුම අතහැර යාමට අසමත් විය",
    "doneFailed": "ඇමතුම සම්පූර්ණ ලෙස සලකුණු කිරීමට අසමත් විය",
    "undoFailed": "ඇමතුම් තත්ත්වය ප්‍රතිස්ථාපනය කිරීමට අසමත් විය",
    "deleteFailed": "ඇමතුම මකීමට අසමත් විය",
    "rescheduleTitle": "නැවත කාලසටහනක් සකස් කරන්නද?",
    "rescheduleMsg": "මෙම ඇමතුම කාලය ඉක්මවා ඇත. නැවත කාලසටහනක් සකස් කිරීමට අවශ්‍යද?",
    "reschedule15": "මිනිත්තු 15කින්",
    "reschedule60": "පැය 1කින්",
    "keepOverdue": "පවතින තත්වය තබන්න"
  },
  "onboarding": {
    "slide1Title": "FishMemory වෙත සාදරයෙන් පිළිගනිමු",
    "slide1Sub": "ඔබේ පුද්ගලික ඇමතුම් සහායකයා — WhatsApp මගින් බලගැන්වූ සහ ඔබේ කෙළවර සඳහා නිර්මාණය කළ.",
    "slide2Title": "සාමාන්‍ය ලෙස කතා කරන්න",
    "slide2Sub": "ඔබ සිතන ආකාරයට ඇමතුම් ටයිප් කරන්න: \"හෙට පස්වරු 3ට මවට ඇමතුම් සිහි කරන්න\" — අපි ඉතිරි දේ කළ හැක.",
    "slide3Title": "කිසිවක් අමතක නොකරන්න",
    "slide3Sub": "වේලාවට දැනුම්දීම් ලබා ගන්න, ටැග් සමඟ සංවිධානය වන්න, සහ වැදගත් සියල්ල මත පාලනය තබන්න.",
    "getStarted": "ආරම්භ කරන්න",
    "next": "ඊළඟ",
    "firstReminderTitle": "ඔබේ පළමු ඇමතුම නිර්මාණය කරන්න!",
    "firstReminderHint": "මෙවැනි දෙයක් ටයිප් කරන්න උත්සාහ කරන්න:",
    "firstReminderExample": "හෙට පෙරවරු 9ට ජලය බොන්න මට සිහි කරන්න",
    "gotIt": "හරි!",
    "notifRationaleTitle": "වේලාවට සිටින්න",
    "notifRationaleBody": "FishMemory ඔබට වේලාවට ඇමතුම් සිහි කිරීමට දැනුම්දීම් අවශ්‍යයි. ඔබ නිර්මාණය කරන ඇමතුම් සඳහා පමණක් දැනුම්දීම් ලැබේ.",
    "notifRationaleAllow": "දැනුම්දීම් සක්‍රීය කරන්න",
    "notifRationaleLater": "පසුව විය හැක",
    "swipeHint": "ඉක්මන් ක්‍රියා සඳහා දකුණුට ස්වයිප් කරන්න →",
    "calendarDragHint": "විස්තර කිරීමට ඇදන්න ↕"
  }
}
